
export const getLocalToken = () => {
    var token = localStorage.getItem("hearhourshop")

    if (token === null || token === undefined || token === "") {
        return null
    }
    return token
 }